"use strict";
// For newly added PDF document, please update the aven_backend/src/tests/integrationTesting/tests/pdfChangeDetectionTest.ts
// for it, which is to detect its changes: you need to add a new entry into the pdfsMap, and its
// generated result (golden) into the aven_backend/src/tests/integrationTesting/tests/data/pdfGoldens
// folder.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDocumentAppDisplayName = exports.AUTO_CA_RIN_DOCUMENTS = exports.NATIONWIDE_PURCHASE_FLH_DISCLOSURE_DOCUMENT_TITLES = exports.NATIONWIDE_PURCHASE_FLH_DISCLOSURE_DOCUMENT_NAMES = exports.DocumentName = exports.LEGAL_PDF_SOURCE = exports.LEGAL_TEMPLATE_SOURCE = void 0;
// Misc constants
exports.LEGAL_TEMPLATE_SOURCE = 'src/legalTemplates'; // Base path for legal templates
exports.LEGAL_PDF_SOURCE = 'src/data/staticPDFs';
/** @TranslateToPython */
var DocumentName;
(function (DocumentName) {
    // Not a generated document but a key for retrieving dot, short or long
    DocumentName["HelocDeedOfTrust"] = "HelocDeedOfTrust";
    // Screenshot of the LPT from notarization
    DocumentName["LastTransferDocument"] = "LastTransferDocument";
    // Gets generated on Irs1098Controller.generateIrs1098ForAnAccountHelper leave as is for now
    DocumentName["Irs1098"] = "Irs1098";
    DocumentName["Irs4506cPreview"] = "Irs4506cPreview";
    DocumentName["Irs4506cSigned"] = "Irs4506cSigned";
    DocumentName["Irs4506cCoverPage"] = "Irs4506cCoverPage";
    DocumentName["IrsRejectionNotice"] = "IrsRejectionNotice";
    DocumentName["SignedDocumentTrail"] = "SignedDocumentTrail";
    DocumentName["balanceTransferTrailDocPreview"] = "balanceTransferTrailDocPreview";
    DocumentName["balanceTransferTrailDoc"] = "balanceTransferTrailDoc";
    // The estimate of the certificate a Rewards BT Upsell selection produces, rendered from the loan application before
    // the account exists. It omits the account number and the certificate id, because neither exists yet.
    DocumentName["balanceTransferTrailDocPreAccountPreview"] = "balanceTransferTrailDocPreAccountPreview";
    DocumentName["AllCommunications"] = "AllCommunications";
    DocumentName["AllTransactions"] = "AllTransactions";
    DocumentName["LoanApplicationAuditSummary"] = "LoanApplicationAuditSummary";
    DocumentName["DelinquencyNotice"] = "DelinquencyNotice";
    DocumentName["DebtValidationLetterSinger"] = "DebtValidationLetterSinger";
    DocumentName["DebtValidationLetterAvenHome"] = "DebtValidationLetterAvenHome";
    DocumentName["DebtValidationLetterAvenUCC"] = "DebtValidationLetterAvenUCC";
    DocumentName["BreachLetter"] = "BreachLetter";
    DocumentName["BreachLetterCoOwner"] = "BreachLetterCoOwner";
    DocumentName["HcmRemediationNotice"] = "HcmRemediationNotice";
    DocumentName["IllinoisHcmRemediationNotice"] = "IllinoisHcmRemediationNotice";
    DocumentName["FederalHcmRemediationNotice"] = "FederalHcmRemediationNotice";
    DocumentName["MinPayInterestOverchargeRefund"] = "MinPayInterestOverchargeRefund";
    DocumentName["NewMexicoHcmAaRemediationNotice"] = "NewMexicoHcmAaRemediationNotice";
    DocumentName["AccountAgreementAug2024RemediationNotice"] = "AccountAgreementAug2024RemediationNotice";
    DocumentName["AccountAgreementAprMismatchAug2024"] = "AccountAgreementAprMismatchAug2024";
    DocumentName["AccountAgreementApr2025RemediationNotice"] = "AccountAgreementApr2025RemediationNotice";
    DocumentName["GracePeriodInterestOverchargeRefund"] = "GracePeriodInterestOverchargeRefund";
    DocumentName["CustomerNotice"] = "CustomerNotice";
    DocumentName["CorrectionAccountAgreementMargin"] = "CorrectionAccountAgreementMargin";
    DocumentName["CorrectionInterestOvercharge"] = "CorrectionInterestOvercharge";
    DocumentName["CorrectionInterestUndercharge"] = "CorrectionInterestUndercharge";
    DocumentName["NotarizedDocuments"] = "NotarizedDocuments";
    DocumentName["RecordedDeedOfTrust"] = "RecordedDeedOfTrust";
    DocumentName["CreditLimitAdjustment"] = "CreditLimitAdjustment";
    DocumentName["HelocRefiAccountAgreementSupplementCorrection"] = "HelocRefiAccountAgreementSupplementCorrection";
    // Generated documents
    DocumentName["HudGovDoc"] = "HomeOwnershipCounselingServices";
    DocumentName["CreditScoreDisclosure"] = "CreditScoreDisclosure";
    DocumentName["ApplicantCreditScoreDisclosure"] = "ApplicantCreditScoreDisclosure";
    DocumentName["ShortFormDeedOfTrust"] = "ShortFormDeedOfTrust";
    DocumentName["LongFormDeedOfTrust"] = "LongFormDeedOfTrust";
    DocumentName["CertificationOfTrust"] = "CertificationOfTrust";
    DocumentName["NotarialCertificate"] = "NotarialCertificate";
    DocumentName["AccountAgreement"] = "AccountAgreement";
    DocumentName["PrometheusShadowPrequalAgreement"] = "PrometheusShadowPrequalAgreement";
    DocumentName["translationServiceAcknowledgement"] = "translationServiceAcknowledgement";
    DocumentName["AccountAgreementHomeLimitedMode"] = "AccountAgreementHomeLimitedMode";
    DocumentName["NoticeOfRightToCancel"] = "NoticeOfRightToCancel";
    // noticeOfRightToCancelRemediation is a one-time use document. Used for remediation.
    DocumentName["NoticeOfRightToCancelRemediation"] = "NoticeOfRightToCancelRemediation";
    // noticeOfRightToCancelRemediationBundle contains the following documents: (1) the account signing docs we sent the user at OG time, (2) the account signing docs we sent the user at CLI time, (3) the new rescission notice
    DocumentName["NoticeOfRightToCancelRemediationBundle"] = "NoticeOfRightToCancelRemediationBundle";
    DocumentName["AdverseActionNotice"] = "AdverseActionNotice";
    DocumentName["CorrectedAdverseActionNotice"] = "CorrectedAdverseActionNotice";
    DocumentName["FictitiousDeedOfTrust"] = "FictitiousDeedOfTrust";
    /**
     * @deprecated New documents render the static copy via StaticEarlyHELOCDisclosure; this member stays for documents already generated and stored.
     * We must get the Early HELOC Disclosure Agreement to be unstatic (dynamic) in the long run, so it auto-updates to product changes.
     */
    DocumentName["EarlyHELOCDisclosure"] = "EarlyHELOCDisclosure";
    DocumentName["StaticEarlyHELOCDisclosure"] = "StaticEarlyHELOCDisclosure";
    DocumentName["PricingAndTerms"] = "PricingAndTerms";
    DocumentName["PropertyValuation"] = "PropertyValuation";
    DocumentName["PropertyValuationTimingWaiver"] = "PropertyValuationTimingWaiver";
    DocumentName["AvmPropertyValuation"] = "AvmPropertyValuation";
    DocumentName["AppraisalWaiver"] = "AppraisalWaiver";
    DocumentName["CorrectionAgreement"] = "CorrectionAgreement";
    DocumentName["PayoffQuote"] = "PayoffQuote";
    DocumentName["PaydownQuote"] = "PaydownQuote";
    DocumentName["AvenStatement"] = "AvenStatement";
    // Legacy document name starting with lower case.
    DocumentName["exhibitALegalPropertyDescriptionText"] = "exhibitALegalPropertyDescriptionText";
    DocumentName["FloodNotificationDisclosure"] = "FloodNotificationDisclosure";
    DocumentName["LoanBrokerageAgreement"] = "LoanBrokerageAgreement";
    DocumentName["PifTerms"] = "PifTerms";
    DocumentName["PifForAllTerms"] = "PifForAllTerms";
    DocumentName["PifTravelTerms"] = "PifTravelTerms";
    DocumentName["InitialExpiringFloodInsuranceWarning"] = "InitialExpiringFloodInsuranceWarning";
    DocumentName["FinalExpiringFloodInsuranceWarning"] = "FinalExpiringFloodInsuranceWarning";
    DocumentName["NoticeOfForcePlacementOfFloodInsurance"] = "NoticeOfForcePlacementOfFloodInsurance";
    DocumentName["InitialExpiringFloodInsuranceCourtesyNotice"] = "InitialExpiringFloodInsuranceCourtesyNotice";
    DocumentName["SecondExpiringFloodInsuranceCourtesyNotice"] = "SecondExpiringFloodInsuranceCourtesyNotice";
    DocumentName["AmazonPromoTerms"] = "AmazonPromoTerms";
    DocumentName["AmazonPromoTerms10"] = "AmazonPromoTerms10";
    DocumentName["AmazonPromoTerms25"] = "AmazonPromoTerms25";
    DocumentName["TaxPromoTerms"] = "TaxPromoTerms";
    // home account closure
    DocumentName["AccountClosureConfirmation"] = "AccountClosureConfirmation";
    DocumentName["AccountClosurePreReconveyanceConfirmation"] = "AccountClosurePreReconveyanceConfirmation";
    DocumentName["UccAccountClosureConfirmation"] = "UccAccountClosureConfirmation";
    DocumentName["CryptoAccountClosureConfirmation"] = "CryptoAccountClosureConfirmation";
    DocumentName["VerificationOfMortgage"] = "VerificationOfMortgage";
    DocumentName["TermsOfService"] = "TermsOfService";
    DocumentName["PrivacyPolicy"] = "PrivacyPolicy";
    DocumentName["AgavePrivacyPolicy"] = "AgavePrivacyPolicy";
    DocumentName["GuaranteedRate"] = "GuaranteedRate";
    DocumentName["GuaranteedProtection"] = "GuaranteedProtection";
    // UCC Guaranteed Rate
    DocumentName["GuaranteedRateAsset"] = "GuaranteedRateAsset";
    // Mortgage Guaranteed Rate
    DocumentName["GuaranteedRateMortgageRefinance"] = "GuaranteedRateMortgageRefinance";
    DocumentName["LoGiftCard"] = "LOGiftCard";
    DocumentName["HelocGuaranteedLowestCost"] = "HelocGuaranteedLowestCost";
    DocumentName["HelocGuaranteedPayment"] = "HelocGuaranteedPayment";
    DocumentName["CashOutUpFront"] = "CashOutUpFront";
    DocumentName["CashOutUpFront100"] = "CashOutUpFront100";
    DocumentName["FullDrawSupplement"] = "FullDrawSupplement";
    DocumentName["CreditLineIncreaseDOTAmendment"] = "CreditLineIncreaseDOTAmendment";
    DocumentName["Reconveyance"] = "Reconveyance";
    DocumentName["CertificateOfAuthenticity"] = "CertificateOfAuthenticity";
    DocumentName["AvenAccountTerminationLetter"] = "AvenAccountTerminationLetter";
    DocumentName["AccountRevocationNoticeFraudAbuse"] = "AccountRevocationNoticeFraudAbuse";
    DocumentName["AccountRevocationNoticePaymentAbuse"] = "AccountRevocationNoticePaymentAbuse";
    DocumentName["AccountRevocationNoticeLienStacking"] = "AccountRevocationNoticeLienStacking";
    DocumentName["TangibleNetBenefitsDisclosure"] = "TangibleNetBenefitsDisclosure";
    DocumentName["PrimeV3ActivationSupplement"] = "PrimeV3ActivationSupplement";
    DocumentName["EngagementSipOfferSupplement"] = "EngagementSipOfferSupplement";
    DocumentName["Cashback50Promo15Terms"] = "Cashback50Promo15Terms";
    DocumentName["Cashback15Terms"] = "Cashback15Terms";
    DocumentName["Cashback20Terms"] = "Cashback20Terms";
    DocumentName["CashbackTerms"] = "CashbackTerms";
    DocumentName["MortgagePaymentCashback10Terms"] = "MortgagePaymentCashback10Terms";
    DocumentName["MortgagePaymentCashbackV2Terms"] = "MortgagePaymentCashbackV2Terms";
    DocumentName["BalanceTransferSweepAddendum"] = "BalanceTransferSweepAddendum";
    // The rewards BT sweep's 0% intro promo variant of the sweep addendum: same supplement role, but it discloses the
    // promotional rate, the promo window, and the post-promo rate/payment, and grants the limited power of attorney.
    DocumentName["RewardsBtSweepPromoAddendum"] = "RewardsBtSweepPromoAddendum";
    DocumentName["AvenSimpleLoanCardholderAgreementSupplementPreview"] = "AvenSimpleLoanCardholderAgreementSupplementPreview";
    DocumentName["AvenSimpleLoanCardholderAgreementSupplementSigned"] = "AvenSimpleLoanCardholderAgreementSupplementSigned";
    DocumentName["HardshipReliefOfferAgreementSupplementPreview"] = "HardshipReliefOfferAgreementSupplementPreview";
    DocumentName["HardshipReliefOfferAgreementSupplementSigned"] = "HardshipReliefOfferAgreementSupplementSigned";
    // Notary's copy of the LoanBrokerageAgreement. Contains signature lines
    DocumentName["LoanBrokerageAgreementNotary"] = "LoanBrokerageAgreementNotary";
    DocumentName["AgencyRelationshipDisclosure"] = "AgencyRelationshipDisclosure";
    DocumentName["AgencyRelationshipDisclosureNotary"] = "AgencyRelationshipDisclosureNotary";
    // State specific
    DocumentName["RightToChooseInsuranceProviderAlabama"] = "RightToChooseInsuranceProviderAlabama";
    DocumentName["AntiCoercionAlaska"] = "AntiCoercionAlaska";
    DocumentName["AntiCoercionFlorida"] = "AntiCoercionFlorida";
    DocumentName["AntiCoercionMissouri"] = "AntiCoercionMissouri";
    DocumentName["MortgageLoanDisclosureFormDC"] = "MortgageLoanDisclosureFormDC";
    DocumentName["DisclosureOfGoverningAuthorityKansas"] = "DisclosureOfGoverningAuthorityKansas";
    DocumentName["LoanBrokerageAgreementKansas"] = "LoanBrokerageAgreementKansas";
    DocumentName["AccountAgreementNoticeNebraska"] = "AccountAgreementNoticeNebraska";
    DocumentName["NebraskaNetTangibleBenefitDisclosureForm"] = "NebraskaNetTangibleBenefitDisclosureForm";
    DocumentName["DisclosureOfPaymentApplicationNewHampshire"] = "DisclosureOfPaymentApplicationNewHampshire";
    DocumentName["AdvancedFeeDisclosureNewHampshire"] = "AdvancedFeeDisclosureNewHampshire";
    DocumentName["HomebuyerProtectionActOhio"] = "HomebuyerProtectionActOhio";
    DocumentName["DisclosureOfRightNotToCloseOhio"] = "DisclosureOfRightNotToCloseOhio";
    DocumentName["OhioRightToChooseInsurance"] = "OhioRightToChooseInsurance";
    DocumentName["OhioEcoaDiscriminationDisclosure"] = "OhioEcoaDiscriminationDisclosure";
    DocumentName["KentuckyFreeChoiceOfInsurance"] = "KentuckyFreeChoiceOfInsurance";
    DocumentName["KentuckyFairHousingBrochure"] = "KentuckyFairHousingBrochure";
    DocumentName["KentuckyHomeownershipProtection"] = "KentuckyHomeownershipProtection";
    // Naming convention here is different for backwards compatibility
    DocumentName["ColoradoLockInDisclosure"] = "Colorado Lock-In Disclosure";
    DocumentName["ColoradoLockInDisclosureNotary"] = "ColoradoLockInDisclosureNotary";
    // Naming convention here is different for backwards compatibility
    DocumentName["ColoradoTangibleNetBenefitDisclosure"] = "Colorado Tangible Net Benefit Disclosure";
    DocumentName["ColoradoTangibleNetBenefitDisclosureNotary"] = "ColoradoTangibleNetBenefitDisclosureNotary";
    DocumentName["MarylandTangibleNetBenefitDisclosure"] = "MarylandTangibleNetBenefitDisclosure";
    DocumentName["MarylandInstrumentIntakeSheet"] = "MarylandInstrumentIntakeSheet";
    DocumentName["MarylandDivorceRelatedAssumption"] = "MarylandDivorceRelatedAssumption";
    DocumentName["MarylandDisclosureOfCertainMortgageLoanProvisions"] = "MarylandDisclosureOfCertainMortgageLoanProvisions";
    // Naming convention here is different for backwards compatibility
    DocumentName["BundledAgreementsIllinois"] = "Loan Brokerage Agreement, Borrower Information Document and Illinois Lock-In Disclosure";
    DocumentName["CreditEligibilityRequirementsIllinois"] = "CreditEligibilityRequirementsIllinois";
    DocumentName["RateLockAgreementIllinois"] = "RateLockAgreementIllinois";
    DocumentName["RateLockAgreementWashington"] = "RateLockAgreementWashington";
    DocumentName["ApplicationDisclosureWisconsin"] = "ApplicationDisclosureWisconsin";
    DocumentName["ConsumerDisclosureWisconsin"] = "ConsumerDisclosureWisconsin";
    DocumentName["NotaryConsumerDisclosureWisconsin"] = "NotaryConsumerDisclosureWisconsin";
    DocumentName["MortgageBrokerAgreementWisconsin"] = "MortgageBrokerAgreementWisconsin";
    DocumentName["NotaryMortgageBrokerAgreementWisconsin"] = "NotaryMortgageBrokerAgreementWisconsin";
    DocumentName["MaritalPurposeStatementWisconsin"] = "MaritalPurposeStatementWisconsin";
    DocumentName["NotaryMortgageOriginationAgreementMississippi"] = "NotaryMortgageOriginationAgreementMississippi";
    DocumentName["MortgageOriginationAgreementMississippi"] = "MortgageOriginationAgreementMississippi";
    DocumentName["NotaryAttorneyInsurancePreferenceSouthCarolina"] = "NotaryAttorneyInsurancePreferenceSouthCarolina";
    DocumentName["MoneyBrokerAgreementNorthDakota"] = "MoneyBrokerAgreementNorthDakota";
    DocumentName["NotaryMoneyBrokerAgreementNorthDakota"] = "NotaryMoneyBrokerAgreementNorthDakota";
    DocumentName["LoanDisclosureStatementNorthDakota"] = "LoanDisclosureStatementNorthDakota";
    DocumentName["NotaryLoanDisclosureStatementNorthDakota"] = "NotaryLoanDisclosureStatementNorthDakota";
    DocumentName["AddendumResidentialMortgageLoanApplicationNewJersey"] = "AddendumResidentialMortgageLoanApplicationNewJersey";
    DocumentName["AttorneyFeeDisclosureNewJersey"] = "AttorneyFeeDisclosureNewJersey";
    DocumentName["NotaryAttorneyFeeDisclosureNewJersey"] = "NotaryAttorneyFeeDisclosureNewJersey";
    DocumentName["AttorneyRepresentationDisclosureNewJersey"] = "AttorneyRepresentationDisclosureNewJersey";
    DocumentName["NotaryAttorneyRepresentationDisclosureNewJersey"] = "NotaryAttorneyRepresentationDisclosureNewJersey";
    DocumentName["MortgageBrokerAgreementNewJersey"] = "MortgageBrokerAgreementNewJersey";
    DocumentName["NotaryMortgageBrokerAgreementNewJersey"] = "NotaryMortgageBrokerAgreementNewJersey";
    DocumentName["RateLockAgreementNewMexico"] = "RateLockAgreementNewMexico";
    DocumentName["AdvancedFeeAndMortgageSummaryNewMexico"] = "AdvancedFeeAndMortgageSummaryNewMexico";
    DocumentName["NotaryAdvancedFeeAndMortgageSummaryNewMexico"] = "NotaryAdvancedFeeAndMortgageSummaryNewMexico";
    DocumentName["LicenseeInformationDisclosureIdaho"] = "LicenseeInformationDisclosureIdaho";
    DocumentName["NotaryLicenseeInformationDisclosureIdaho"] = "NotaryLicenseeInformationDisclosureIdaho";
    DocumentName["DisclosureToConsumerMaine"] = "DisclosureToConsumerMaine";
    DocumentName["NotaryDisclosureToConsumerMaine"] = "NotaryDisclosureToConsumerMaine";
    DocumentName["MortgageBrokerAgreementMaine"] = "MortgageBrokerAgreementMaine";
    DocumentName["NotaryMortgageBrokerAgreementMaine"] = "NotaryMortgageBrokerAgreementMaine";
    DocumentName["ApplicationDisclosureVirginia"] = "ApplicationDisclosureVirginia";
    DocumentName["NotaryApplicationDisclosureVirginia"] = "NotaryApplicationDisclosureVirginia";
    DocumentName["MortgageBrokerAgreementVirginia"] = "MortgageBrokerAgreementVirginia";
    DocumentName["NotaryMortgageBrokerAgreementVirginia"] = "NotaryMortgageBrokerAgreementVirginia";
    DocumentName["ForeclosureDisclosureGeorgia"] = "ForeclosureDisclosureGeorgia";
    DocumentName["NotaryForeclosureDisclosureGeorgia"] = "NotaryForeclosureDisclosureGeorgia";
    DocumentName["MortgageCompanyDisclosureTexasPreview"] = "MortgageCompanyDisclosureTexasPreview";
    DocumentName["MortgageCompanyDisclosureTexasSigned"] = "MortgageCompanyDisclosureTexasSigned";
    DocumentName["TexasMortgageCompanyDisclosures"] = "TexasMortgageCompanyDisclosures";
    DocumentName["TexasTwelveDayNotice"] = "TexasTwelveDayNotice";
    DocumentName["TexasLoanApplicationSummary"] = "TexasLoanApplicationSummary";
    DocumentName["NotaryAcknowledgementOfFairMarketValueDisclosureTexas"] = "NotaryAcknowledgementOfFairMarketValueDisclosureTexas";
    DocumentName["NotaryNoticeOfPenaltiesForFalseStatementsTexas"] = "NotaryNoticeOfPenaltiesForFalseStatementsTexas";
    DocumentName["NotaryTexasHomeEquityAffidavit"] = "NotaryTexasHomeEquityAffidavit";
    DocumentName["NotaryAffidavitOfMaritalStatusTexas"] = "NotaryAffidavitOfMaritalStatusTexas";
    DocumentName["NotaryDebtsLiensAndPossessionAffidavitTexas"] = "NotaryDebtsLiensAndPossessionAffidavitTexas";
    DocumentName["NotaryAkaAffidavitTexas"] = "NotaryAkaAffidavitTexas";
    DocumentName["FloodNoticeToBorrower"] = "FloodNoticeToBorrower";
    DocumentName["LowDataBreachDisclosure"] = "LowDataBreachDisclosure";
    DocumentName["MediumDataBreachDisclosure"] = "MediumDataBreachDisclosure";
    DocumentName["HighDataBreachDisclosure"] = "HighDataBreachDisclosure";
    DocumentName["ApplicationDisclosureVermont"] = "ApplicationDisclosureVermont";
    DocumentName["NotaryApplicationDisclosureVermont"] = "NotaryApplicationDisclosureVermont";
    DocumentName["MortgageBrokerAgreementVermont"] = "MortgageBrokerAgreementVermont";
    DocumentName["NotaryMortgageBrokerAgreementVermont"] = "NotaryMortgageBrokerAgreementVermont";
    DocumentName["NotaryClosingStatementWestVirginia"] = "NotaryClosingStatementWestVirginia";
    DocumentName["LoanOriginationDisclosureMontana"] = "LoanOriginationDisclosureMontana";
    DocumentName["NotaryLoanOriginationDisclosureMontana"] = "NotaryLoanOriginationDisclosureMontana";
    DocumentName["CSOAgreementWestVirginia"] = "CSOAgreementWestVirginia";
    DocumentName["NotaryCSOAgreementWestVirginia"] = "NotaryCSOAgreementWestVirginia";
    DocumentName["CSODisclosureWestVirginia"] = "CSODisclosureWestVirginia";
    DocumentName["NotaryHomeLoanProtectionDisclosureRhodeIsland"] = "NotaryHomeLoanProtectionDisclosureRhodeIsland";
    DocumentName["ProhibitedActsRhodeIsland"] = "ProhibitedActsRhodeIsland";
    DocumentName["MortgageBrokerAgreementDelaware"] = "MortgageBrokerAgreementDelaware";
    DocumentName["NotaryMortgageBrokerAgreementDelaware"] = "NotaryMortgageBrokerAgreementDelaware";
    DocumentName["MortgageBrokerAgreementSouthCarolina"] = "MortgageBrokerAgreementSouthCarolina";
    DocumentName["MortgageBrokerAgreementCalifornia"] = "MortgageBrokerAgreementCalifornia";
    DocumentName["MortgageBrokerAgreementMissouri"] = "MortgageBrokerAgreementMissouri";
    DocumentName["CaliforniaFairLendingNotice"] = "CaliforniaFairLendingNotice";
    DocumentName["CaliforniaTitleInsuranceDisclosure"] = "CaliforniaTitleInsuranceDisclosure";
    DocumentName["ArizonaRightToChooseInsurance"] = "ArizonaRightToChooseInsurance";
    DocumentName["CaliforniaHazardInsuranceDisclosure"] = "CaliforniaHazardInsuranceDisclosure";
    DocumentName["CaliforniaStatementOfInterestAddendum"] = "CaliforniaStatementOfInterestAddendum";
    DocumentName["CaliforniaNoticeToHomeLoanApplicant"] = "CaliforniaNoticeToHomeLoanApplicant";
    DocumentName["FloridaNoticeToPurchaserMortgagor"] = "FloridaNoticeToPurchaserMortgagor";
    DocumentName["EcoaNotice"] = "EcoaNotice";
    DocumentName["MontanaRightToChooseInsurance"] = "MontanaRightToChooseInsurance";
    DocumentName["ColoradoRightToChooseInsurance"] = "ColoradoRightToChooseInsurance";
    DocumentName["UtahLoanNotice"] = "UtahLoanNotice";
    DocumentName["OregonAddendumResidentialMortgageLoanApplication"] = "OregonAddendumResidentialMortgageLoanApplication";
    DocumentName["OregonChoiceOfInsurance"] = "OregonChoiceOfInsurance";
    DocumentName["OregonStatuteOfFraudsDisclosure"] = "OregonStatuteOfFraudsDisclosure";
    DocumentName["FederalInsuranceDisclosure"] = "FederalInsuranceDisclosure";
    // Auto specific
    DocumentName["AccountAgreementAuto"] = "AccountAgreementAuto";
    DocumentName["PricingAndTermsAuto"] = "PricingAndTermsAuto";
    DocumentName["CaliforniaPowerOfAttorney"] = "CaliforniaPowerOfAttorney";
    DocumentName["CaliforniaBillOfSale"] = "CaliforniaBillOfSale";
    DocumentName["CaliforniaApplicationForReplacementOrTransferOfTitle"] = "CaliforniaApplicationForReplacementOrTransferOfTitle";
    DocumentName["CaliforniaCourtesyStopRequest"] = "CaliforniaCourtesyStopRequest";
    DocumentName["CaliforniaApplicationForTitleOrRegistration"] = "CaliforniaApplicationForTitleOrRegistration";
    // MLO specific
    DocumentName["MloBrokerAgreement"] = "MloBrokerAgreement";
    DocumentName["MloBrokerAgreementBrokerSigned"] = "MloBrokerAgreementBrokerSigned";
    // Partner program specific
    DocumentName["PartnerBrokerAgreement"] = "PartnerBrokerAgreement";
    DocumentName["PartnerDistributorAgreement"] = "PartnerDistributorAgreement";
    DocumentName["BackfillPartnerBrokerAgreement"] = "BackfillPartnerBrokerAgreement";
    DocumentName["PartnerBrokerDisclosureCreditKarmaArizona"] = "PartnerBrokerDisclosureCreditKarmaArizona";
    DocumentName["PartnerBrokerDisclosureCreditKarmaDelaware"] = "PartnerBrokerDisclosureCreditKarmaDelaware";
    DocumentName["PartnerBrokerDisclosureCreditKarmaNewJersey"] = "PartnerBrokerDisclosureCreditKarmaNewJersey";
    DocumentName["PartnerBrokerDisclosureCreditKarmaWashington"] = "PartnerBrokerDisclosureCreditKarmaWashington";
    DocumentName["PartnerBrokerDisclosureCreditKarmaWisconsin"] = "PartnerBrokerDisclosureCreditKarmaWisconsin";
    DocumentName["PartnerBrokerLicenseAffirmationSouthCarolina"] = "PartnerBrokerLicenseAffirmationSouthCarolina";
    // Mortgage brokering specific
    DocumentName["MortgageRefinanceDocument"] = "MortgageRefinanceDocument";
    // Churn retention specific
    DocumentName["RetentionOfferAccountAgreementAddenda"] = "RetentionOfferAccountAgreementAddenda";
    // Purchase HELOC specific
    DocumentName["PurchaseHelocPreQualLetter"] = "PurchaseHelocPreQualLetter";
    DocumentName["PurchaseHelocPreApprovalLetter"] = "PurchaseHelocPreApprovalLetter";
    // Purchase HELOC settlement specific
    DocumentName["AvenPurchaseSettlementStatement"] = "AvenPurchaseSettlementStatement";
    DocumentName["AvenPurchaseBalancingConfirmation"] = "AvenPurchaseBalancingConfirmation";
    DocumentName["AvenPurchaseClosingInstructions"] = "AvenPurchaseClosingInstructions";
    // HELOC REFI specific
    DocumentName["BorrowerCloseAccountAuthorization"] = "BorrowerCloseAccountAuthorization";
    DocumentName["BorrowerCloseAccountAuthorizationSigned"] = "BorrowerCloseAccountAuthorizationSigned";
    DocumentName["BorrowerCloseAccountAuthorizationUnsigned"] = "BorrowerCloseAccountAuthorizationUnsigned";
    DocumentName["StewartBorrowerPayoffAuthorization"] = "StewartBorrowerPayoffAuthorization";
    DocumentName["StewartBorrowerPayoffAuthorizationUnsigned"] = "StewartBorrowerPayoffAuthorizationUnsigned";
    DocumentName["LenderClosingInstructions"] = "LenderClosingInstructions";
    DocumentName["TexasLenderClosingInstructions"] = "TexasLenderClosingInstructions";
    // DEBT PROTECTION specific
    DocumentName["DebtProtectionAddendum"] = "DebtProtectionAddendum";
    // UCC
    DocumentName["UccPricingAndTerms"] = "UccPricingAndTerms";
    DocumentName["uccPricingAndTermsSigned"] = "uccPricingAndTermsSigned";
    DocumentName["UccSecurityAgreement"] = "UccSecurityAgreement";
    DocumentName["UccAccountAgreement"] = "UccAccountAgreement";
    DocumentName["uccLatestAccountAgreement"] = "uccLatestAccountAgreement";
    DocumentName["uccAccountAgreementPreview"] = "uccAccountAgreementPreview";
    DocumentName["uccAccountAgreementSigned"] = "uccAccountAgreementSigned";
    DocumentName["UccCreditScoreDisclosure"] = "UccCreditScoreDisclosure";
    DocumentName["UccAccountAgreementZeroPctBTSupplement"] = "UccAccountAgreementZeroPctBTSupplement";
    DocumentName["UccAccountAgreementGuaranteedAprBeatSupplement"] = "UccAccountAgreementGuaranteedAprBeatSupplement";
    DocumentName["UccCreditLimitIncreaseCertificate"] = "UccCreditLimitIncreaseCertificate";
    DocumentName["UccGuaranteedAprBeatTermsAndConditions"] = "UccGuaranteedAprBeatTermsAndConditions";
    DocumentName["UccGroceries6Pct"] = "UccGroceries6Pct";
    DocumentName["UccGas6Pct"] = "UccGas6Pct";
    DocumentName["UccOneYearOfStarbucksPromotion"] = "UccOneYearOfStarbucksPromotion";
    // Promotions
    DocumentName["OneYearOfStarbucksPromotion"] = "OneYearOfStarbucksPromotion";
    DocumentName["CostcoRewardsPromotion"] = "CostcoRewardsPromotion";
    DocumentName["FloodGateHomeDepotPromotion"] = "FloodGateHomeDepotPromotion";
    DocumentName["FloodGateHomeDepot5PercentPromotion"] = "FloodGateHomeDepot5PercentPromotion";
    DocumentName["Restaurants7PercentPromotion"] = "Restaurants7PercentPromotion";
    DocumentName["AmazonPrimeMembershipPromotion"] = "AmazonPrimeMembershipPromotion";
    DocumentName["GroupCardholderRewardsPromotion"] = "GroupCardholderRewardsPromotion";
    DocumentName["GasAndGroceries7Percent"] = "GasAndGroceries7Percent";
    DocumentName["ThreePercentCbOnUpTo100kPromotion"] = "ThreePercentCbOnUpTo100kPromotion";
    DocumentName["PropertyTaxBenefits"] = "PropertyTaxBenefits";
    DocumentName["ApplicationDisclosureAndSummary"] = "ApplicationDisclosureAndSummary";
    DocumentName["CardholderIrs1099Misc"] = "CardholderIrs1099Misc";
    DocumentName["LegalRepresentationNotice"] = "LegalRepresentationNotice";
    DocumentName["NoInterimFinancingDisclosure"] = "NoInterimFinancingDisclosure";
    // ServiceLink
    DocumentName["AvenClosingPackage"] = "AvenClosingPackage";
    // Home Depot Gift Card
    DocumentName["HomeDepotGiftCardTerms"] = "HomeDepotGiftCardTerms";
    // Loan Guaranteed Payment
    DocumentName["LoanGuaranteedPaymentTerms"] = "LoanGuaranteedPaymentTerms";
    // Contribution Rewards
    DocumentName["PtaRewardsAndConditions"] = "PtaRewardsAndConditions";
    DocumentName["ShortFormDeedOfTrustSigned"] = "ShortFormDeedOfTrustSigned";
    DocumentName["LongFormDeedOfTrustSigned"] = "LongFormDeedOfTrustSigned";
    DocumentName["FloodInsuranceDocumentName"] = "FloodInsurance";
    DocumentName["HomeOwnersInsuranceDocumentName"] = "HomeOwnersInsurance";
    DocumentName["LoremIpsum"] = "Lorem Ipsum";
    DocumentName["HomeCashbackWithUccBundleTerms"] = "HomeCashbackWithUccBundleTerms";
    DocumentName["SampleTsxDocument"] = "SampleTsxDocument";
    DocumentName["AccountAgreementAddendumHelocRefi"] = "AccountAgreementAddendumHelocRefi";
    DocumentName["AvenCashUpfrontHelocRefiAddendum"] = "AvenCashUpfrontHelocRefiAddendum";
    DocumentName["DepositAccountAgreement"] = "DepositAccountAgreement";
    DocumentName["DepositAccountAgreementSigned"] = "DepositAccountAgreementSigned";
    DocumentName["DepositWireFraudDetailsVerified"] = "DepositWireFraudDetailsVerified";
    DocumentName["DepositWireFraudIrreversibleAcknowledged"] = "DepositWireFraudIrreversibleAcknowledged";
    DocumentName["DepositWireAccuracyAcknowledged"] = "DepositWireAccuracyAcknowledged";
    DocumentName["AvenCashBackTermsAndConditions"] = "AvenCashBackTermsAndConditions";
    DocumentName["DepositPeriodicStatement"] = "DepositPeriodicStatement";
    DocumentName["DepositAchExternalAccountLinkingAuthorization"] = "DepositAchExternalAccountLinkingAuthorization";
    DocumentName["DepositAchRecurringPaymentAuthorization"] = "DepositAchRecurringPaymentAuthorization";
    DocumentName["DepositAchDirectDepositEnrollmentAuthorization"] = "DepositAchDirectDepositEnrollmentAuthorization";
    /**
     * Document focused on explaining the reward boosts in detail.
     */
    DocumentName["PromotionalTermsAndConditions"] = "PromotionalTermsAndConditions";
    DocumentName["AutoPayAgreement"] = "AutoPayAgreement";
    /**
     * Terms and conditions for the Rewards Card Referral Program.
     */
    DocumentName["RewardsCardReferralProgramTermsAndConditions"] = "RewardsCardReferralProgramTermsAndConditions";
    // Crypto agreements
    DocumentName["CryptoPricingAndTerms"] = "CryptoPricingAndTerms";
    DocumentName["CryptoPricingAndTermsSigned"] = "CryptoPricingAndTermsSigned";
    DocumentName["CryptoAccountAgreement"] = "CryptoAccountAgreement";
    DocumentName["CryptoAccountAgreementPreview"] = "CryptoAccountAgreementPreview";
    DocumentName["CryptoAccountAgreementSigned"] = "CryptoAccountAgreementSigned";
    DocumentName["CryptoInterestOnlySupplementPreview"] = "CryptoInterestOnlySupplementPreview";
    DocumentName["CryptoInterestOnlySupplementSigned"] = "CryptoInterestOnlySupplementSigned";
    /**
     * E-Sign Consent document.
     */
    DocumentName["ESignConsent"] = "ESignConsent";
    DocumentName["MerchantTcpaConsent"] = "MerchantTcpaConsent";
})(DocumentName || (exports.DocumentName = DocumentName = {}));
exports.NATIONWIDE_PURCHASE_FLH_DISCLOSURE_DOCUMENT_NAMES = [
    DocumentName.StaticEarlyHELOCDisclosure,
    DocumentName.PricingAndTerms,
    DocumentName.HudGovDoc,
    DocumentName.PropertyValuationTimingWaiver,
    DocumentName.EcoaNotice,
];
exports.NATIONWIDE_PURCHASE_FLH_DISCLOSURE_DOCUMENT_TITLES = {
    [DocumentName.StaticEarlyHELOCDisclosure]: 'Early HELOC Disclosure',
    [DocumentName.PricingAndTerms]: 'Pricing and Terms',
    [DocumentName.HudGovDoc]: 'Home Ownership Counseling Disclosure',
    [DocumentName.PropertyValuationTimingWaiver]: 'Property Valuation Timing Waiver',
    [DocumentName.EcoaNotice]: 'ECOA Notice',
};
/** @TranslateToPython */
exports.AUTO_CA_RIN_DOCUMENTS = [
    DocumentName.CaliforniaPowerOfAttorney,
    DocumentName.CaliforniaBillOfSale,
    DocumentName.CaliforniaApplicationForReplacementOrTransferOfTitle,
    DocumentName.CaliforniaCourtesyStopRequest,
    DocumentName.CaliforniaApplicationForTitleOrRegistration,
];
/** @TranslateToPython */
var LegalDocumentAppDisplayName;
(function (LegalDocumentAppDisplayName) {
    LegalDocumentAppDisplayName["irs1098"] = "Form 1098";
    LegalDocumentAppDisplayName["irs1099"] = "Form 1099-Misc";
    LegalDocumentAppDisplayName["delinquencyNotice"] = "Past Due Notice";
    LegalDocumentAppDisplayName["debtValidationLetter"] = "Debt Validation Letter";
    LegalDocumentAppDisplayName["accountAgreementCorrection"] = "Account Agreement Correction";
    LegalDocumentAppDisplayName["interestUndercharge"] = "Interest Undercharge";
    LegalDocumentAppDisplayName["interestOvercharge"] = "Interest Overcharge";
    LegalDocumentAppDisplayName["creditLimitAdjustment"] = "Credit Limit Adjustment";
    LegalDocumentAppDisplayName["hcmRemediationDocument"] = "High Cost Mortgage Options";
    LegalDocumentAppDisplayName["accountAgreementAug2024Correction"] = "Account Agreement Correction";
    LegalDocumentAppDisplayName["accountAgreementAprMismatchAug2024"] = "Account Correction and Refund!";
    LegalDocumentAppDisplayName["hardshipReliefOfferAgreementSupplement"] = "Aven Card Cardholder Agreement Supplement";
    LegalDocumentAppDisplayName["marylandDisclosureOfCertainMortgageLoanProvisions"] = "Maryland Disclosure of Certain Mortgage Loan Provisions";
})(LegalDocumentAppDisplayName || (exports.LegalDocumentAppDisplayName = LegalDocumentAppDisplayName = {}));
